import React from 'react';
import { Card } from '../PrimereactComponents';
import { capitalizeFirstLetter } from '../../utils/texts';
import ChevronLink from '../common/ChevronLink/ChevronLink';
import { useTranslation } from 'react-i18next';
import "./PoliticalBodyCard.css";

const BODY_ICONS = {
    rada: 'gavel',
    zastupitelstvo: 'account_balance',
    snemovna: 'account_balance'
};

export const PoliticalBodyCard = ({ municipality, bodyType, organNameOptionLabels, onClick }) => {
    const { t } = useTranslation();
    const organ = municipality.organy[bodyType];
    const organID = organ?.id;
    const organNamelabel = capitalizeFirstLetter(organID ? organNameOptionLabels[organID]?.label ?? bodyType : '');
    const accentColor = municipality.barva || '#6366f1';

    return (
        <div className='municipality-card-wrapper'>
            <Card onClick={onClick} className='municipality-card hoverable-card'>
                <div className='municipality-card-top'>
                    <div className='municipality-card-icon' style={{ background: `${accentColor}1a`, color: accentColor }}>
                        <span className='material-symbols-rounded'>{BODY_ICONS[bodyType] ?? 'groups'}</span>
                    </div>
                    <div>
                        <h2 className='municipality-card-text'>{organNamelabel}</h2>
                        {organ?.misto && <p className='municipality-card-sub'>{organ.misto}</p>}
                    </div>
                </div>
                {typeof organ?.pocet_zastupitelu === 'number' && (
                    <span className='municipality-card-fact' style={{ background: `${accentColor}1a`, color: accentColor }}>
                        <span className='material-symbols-rounded'>groups</span>
                        {t('Bodies.memberCount', { count: organ.pocet_zastupitelu })}
                    </span>
                )}
                <ChevronLink chevronDirection='right' text={t('Bodies.viewVotings')} linkDisabled className='municipality-card-cta' />
            </Card>
        </div>
    );
};
